import { __assign, __extends } from "tslib";
import React from 'react';
import { ThemeContext } from '@skbkontur/react-ui/lib/theming/ThemeContext';
import { ArrowChevronDownIcon as ArrowChevronDown } from '@skbkontur/react-ui/internal/icons/16px';
import { getAddonsTheme } from '../../lib/theming/ThemeHelpers';
import { TopBarDropdown } from './TopBarDropdown';
import { jsStyles } from './TopBar.styles';
/**
 * Дропдаун с организациями
 *
 * @visibleName TopBar.OrganizationsDropdown
 */

var TopBarOrganizations =
/** @class */
function (_super) {
  __extends(TopBarOrganizations, _super);

  function TopBarOrganizations() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      captionWhiteSpace: 'normal',
      minWidth: null
    };

    _this._getCaptionRef = function (element) {
      _this._caption = element;
    };

    _this._getCommentRef = function (element) {
      _this._comment = element;
    };

    return _this;
  }

  TopBarOrganizations.prototype.componentDidMount = function () {
    this._recalculateWidth();
  };

  TopBarOrganizations.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.caption !== this.props.caption) {
      this._recalculateWidth();
    }
  };

  TopBarOrganizations.prototype.render = function () {
    var _this = this;

    return React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this.theme = getAddonsTheme(theme);
      return React.createElement(ThemeContext.Provider, {
        value: _this.theme
      }, _this.renderMain());
    });
  };

  TopBarOrganizations.prototype.renderMain = function () {
    var _a = this.props,
        caption = _a.caption,
        comment = _a.comment;
    var captionNode = React.createElement("div", {
      className: jsStyles.organizationsCaption(this.theme)
    }, caption);
    var title = React.createElement("div", null, React.createElement("span", {
      className: jsStyles.organizationsTitle(this.theme),
      style: {
        paddingRight: this._comment ? this._comment.offsetWidth + 30 : undefined
      }
    }, React.createElement("span", {
      ref: this._getCaptionRef
    }, captionNode), comment && React.createElement("span", {
      className: jsStyles.organizationsComment(this.theme),
      ref: this._getCommentRef
    }, comment), React.createElement("span", {
      className: jsStyles.organizationsArrow()
    }, React.createElement(ArrowChevronDown, {
      color: "#aaa",
      size: 14
    }))), React.createElement("div", {
      className: jsStyles.organizationsTitleDummy(this.theme),
      style: {
        whiteSpace: this.state.captionWhiteSpace
      }
    }, React.createElement("span", null, captionNode), comment && React.createElement("span", {
      className: jsStyles.organizationsCommentDummy(this.theme)
    }, comment)));
    return React.createElement(TopBarDropdown, __assign({}, this.props, {
      label: title,
      minWidth: this.state.minWidth
    }), this.props.children);
  };

  TopBarOrganizations.prototype._recalculateWidth = function () {
    var commentWidth = this._comment ? this._comment.offsetWidth : 0;

    if (!this._caption) {
      return;
    } // 360 is minWidth from guides. Apply it when content is bigger.
    // 315 is because of 15px left padding and 30px arrow.


    if (this._caption.offsetWidth + commentWidth > 315) {
      this.setState({
        captionWhiteSpace: 'normal',
        minWidth: 360
      });
    } else {
      this.setState({
        captionWhiteSpace: 'nowrap',
        minWidth: null
      });
    }
  };

  TopBarOrganizations.__KONTUR_REACT_UI__ = 'TopBarOrganizations';
  return TopBarOrganizations;
}(React.Component);

export { TopBarOrganizations };